module.exports = __webpack_public_path__ + "img/rightAni.33ed191f.png";